import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";

const Routers = () => {
  const token = localStorage.getItem("cvToken");
  const isAuthenticated = !!token;

  return (
    <BrowserRouter basename={"/"}>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={"/"} element={<PrivateRoute />}>
            {isAuthenticated && (
              <>
                <Route
                  path={`${process.env.PUBLIC_URL}`}
                  element={
                    <Navigate
                      to={`${process.env.PUBLIC_URL}/dashboard`}
                      replace
                    />
                  }
                />
                <Route
                  path={`/`}
                  element={
                    <Navigate
                      to={`${process.env.PUBLIC_URL}/dashboard`}
                      replace
                    />
                  }
                />
              </>
            )}

            <Route path={`/*`} element={<LayoutRoutes />} />
          </Route>

          <Route
            path={`${process.env.PUBLIC_URL}/login`}
            element={
              isAuthenticated ? (
                <Navigate
                  to={`${process.env.PUBLIC_URL}/dashboard`}
                  replace
                />
              ) : (
                <Signin />
              )
            }
          />

          {authRoutes.map(({ path, Component }, i) => (
            <Route path={path} element={Component} key={i} />
          ))}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;